import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() hasSession: boolean;
  active: any = false;
  hasPreference: any = false;
  llaveData: any = {};
  url: any = environment.base.url;
  sub_url: any = environment.base.sub_url;

  constructor() {}
  ngOnInit() {
    let preference = window.matchMedia('(prefers-color-scheme: dark)').matches

    this.hasPreference = localStorage.getItem('theme-cdmx') ? true : false;
    this.llaveData = JSON.parse(localStorage.getItem(environment.auth.key));

    if (preference) {
      this.active = true;
    } else {
      this.active = false;
      // this.hasPreference
    }

    // this.active = preference ? false : true;
  }

  ngLogout() {
    localStorage.removeItem('OauthIdentityServiceProvider.CDMX.LastUser');
    window.location.href = "/";
  }

  ngToggle(item) {
    let na: any = document.getElementById("covid19");
    this.hasPreference = localStorage.getItem('theme-cdmx') ? true : false;

    na.classList.toggle("dark");
    this.active = na.classList.contains('dark');
    localStorage.setItem("theme-cdmx", na.classList.contains('dark').toString());
  }

  ngStartSession () {
    window.location.href=`${environment.llave.llave_url}?client_id=${environment.llave.client_id}&redirect_url=${environment.llave.redirect_url}&state=bXH2EHTPhKD1a6UokpnGZETSsaI8k6nZX9eptH688Hs1Qk_AXJZGJjUFODP5Lr8f`;
  }
}
